import { render, staticRenderFns } from "./kplh-template.vue?vue&type=template&id=a400f9d2&"
import script from "./kplh-template.vue?vue&type=script&lang=js&"
export * from "./kplh-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports